import { useState, useMemo } from 'react';
import { useScroll, useResult, useScrolling } from '@rails/document/hooks';
import Frame from './Frame';
import ModalUpload from '@/uploads/Modal';
import { useSelection } from '@react-hooks/use-selection';
import { FrameContext, useFrame } from './FrameContext';
import { useSession } from '@/Session';

const PER_PAGE = 10;

const Frames = () => {
  const {
    session: { userId },
  } = useSession();
  const fetcher = useScroll({ per: PER_PAGE }, 'uploads', {
    where: { userId },
  });
  const uploads = useResult(fetcher);
  const [multiple, setMultiple] = useState(false);
  const selection = useSelection({
    data: uploads,
    multiple,
  });

  const value = useMemo(
    () => ({
      ...selection,
      multiple,
      setMultiple,
    }),
    [selection, multiple],
  );

  return (
    <FrameContext.Provider value={value}>
      <Modal />
      <Fab />
      <FramesView {...{ fetcher }} />
    </FrameContext.Provider>
  );
};

const Modal = () => {
  const selection = useFrame();
  const modal = selection.multiple === false && selection.selected;
  return (
    <ModalUpload
      upload={modal}
      onCloseModal={() => modal && selection.unselect(modal)}
    />
  );
};

import { CancelIcon, TrashIcon } from '@/icons';
const Fab = () => {
  const selection = useFrame();
  const fab = selection.multiple;
  if (!fab) return;
  const handleCancel = () => {
    selection.unselectAll();
    selection.setMultiple(false);
  };
  const handleDelete = () => {
    if (confirm('Supprimer la selection ?')) {
      Promise.all(selection.selected.map((upload) => upload.destroy())).then(
        handleCancel,
      );
    }
  };
  return (
    <div className='fixed bottom-6 right-6 flex flex-row gap-2 z-100'>
      <button
        title='Annuler'
        className='btn btn-lg btn-circle btn-secondary'
        onClick={handleCancel}
      >
        <CancelIcon />
      </button>
      <div className='indicator'>
        {selection.selected.length > 1 && (
          <span className='indicator-item badge border-primary text-primary'>
            {selection.selected.length}
          </span>
        )}
        <button
          title='Supprimer la sélection'
          className='btn btn-lg btn-circle'
          disabled={selection.selected.length === 0}
          onClick={handleDelete}
        >
          <TrashIcon />
        </button>
      </div>
    </div>
  );
};

const FramesView = ({ fetcher }) => {
  const uploads = useResult(fetcher);
  const { setSentry, root, hasNextPage } = useScrolling(fetcher);
  return (
    <div
      ref={root}
      className={`
      min-h-0
      overflow-auto
        grid
        gap-5 justify-items-center justify-center items-center
        xl:grid-cols-6
        lg:grid-cols-4
        md:grid-cols-3
        sm:grid-cols-2
  `}
    >
      {uploads.map((upload) => (
        <div
          ref={setSentry(upload)}
          key={upload.id}
        >
          <Frame upload={upload} />
        </div>
      ))}
      {hasNextPage && (
        <span className='loading loading-infinity loading-xl'></span>
      )}
    </div>
  );
};

export default Frames;
